import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { TABS } from '../pages/tramites-conectividad/tramitesConectividad.utils';

export const selectAuthReducer = (state) => state.auth;

export const isUserAuthenticated = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice.isAuthenticated,
);

export const getUserData = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userDetail,
);

export const getUserPermissionsData = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userPermissions,
);

export const selectUserSurveyResponse = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userSurveyResponse,
);
export const selectManagementUnit = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.managementUnit,
);
export const isUserVisitor = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.isVisitor,
);
export const getUserleftNavigationAndMenuButtons = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userPermissions?.leftNavigationAndMenuButtons,
);
export const getUserDetail = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userDetail,
);
export const getLoginErrorMessage = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.error && authSlice?.message,
);
//forgot password
export const isProviderValid = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.forgotPassword?.providerState?.estado === 'OK',
);
export const getProviderData = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.forgotPassword?.providerState,
);
export const getTokenValidationData = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.forgotPassword?.tokenValidationState,
);

export const getPinMailRegistrationStatus = (state) =>
  state.auth?.forgotPassword?.pinMailState?.estado === 'OK';

export const pinMailCanRetry = (state) =>
  state.auth?.forgotPassword?.tokenValidationState?.estado === 'OK' &&
  !isEmpty(state.auth?.forgotPassword?.tokenValidationState?.fecha);
export const getPinValidationData = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.forgotPassword?.pinValidation,
);

// Register

export const getRegisterProviderData = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.registerUser?.providerState,
);
export const isRegisterProviderValid = (state) =>
  state.auth?.registerUser?.providerState?.estado === 'OK';

//terms
export const userHasAcceptedTerms = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userHasAcceptedTerms,
);
export const getTermsAndConditionsData = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.termsAndConditions,
);
export const getAllUserData = createSelector([selectAuthReducer], (authSlice) => authSlice);

export const isUserAdmin = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userDetail?.modelEspecifico?.admin,
);

export const getProviderCode = createSelector(
  [selectAuthReducer],
  (authSlice) => authSlice?.authData?.userDetail?.modelEspecifico?.codPrestador,
);

export const userHasDOC24Permission = createSelector([selectAuthReducer], (authSlice) => {
  return authSlice?.authData?.userHasDOC24Permission;
});

export const selectPractitionerDoc24 = createSelector([selectAuthReducer], (authSlice) => ({
  practitionerId: authSlice?.authData?.userDetail?.modelEspecifico?.codPrestador,
  email: authSlice?.authData?.userDetail?.modelEspecifico?.emailPrestador,
}));

export const selectConectividadUserPermissions = createSelector(
  [getUserPermissionsData],
  (userPermissionsSlice) => {
    const permissions = userPermissionsSlice?.leftNavigationAndMenuButtons;
    let conectividadPermissions = [];

    permissions.forEach((permission) => {
      if (permission?.id === 'ingreso-de-prestaciones')
        conectividadPermissions.push(TABS.INGRESAR_PRESTACIONES);
      if (permission?.id === 'busqueda-de-tickets') conectividadPermissions.push(TABS.PRESTACIONES);
      if (permission?.id === 'reportes') conectividadPermissions.push(TABS.REPORTE);
      if (permission?.id === 'elegibilidad') conectividadPermissions.push(TABS.ELEGIBILIDAD);
    });

    return conectividadPermissions;
  },
);
